<div class="carousel-container">
    <div class="carousel-slides" [ngStyle]="{'transform': 'translateX(' + translateValue + ')'}">
      <div class="carousel-slide" *ngFor="let slide of slides">
        <img class="carousel-image" [src]="slide.image" alt="{{ slide.caption }}">
        <div class="carousel-caption">
          <h3>{{ slide.caption }}</h3>
        </div>
      </div>
    </div>
    <div class="carousel-pagination">
      <button class="carousel-pagination-item" *ngFor="let slide of slides; let i = index" [ngClass]="{'active': currentIndex === i}"
        (click)="goToSlide(i)"></button>
    </div>
  </div>